import { render, staticRenderFns } from "./BiddingLatestNotification.vue?vue&type=template&id=0bff8ee0&scoped=true"
import script from "./BiddingLatestNotification.vue?vue&type=script&lang=js"
export * from "./BiddingLatestNotification.vue?vue&type=script&lang=js"
import style0 from "./BiddingLatestNotification.vue?vue&type=style&index=0&id=0bff8ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff8ee0",
  null
  
)

export default component.exports